import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  pitch: require("../../../assets/wc/images/pitch.png"),
  trikot: require("../../../assets/wc/images/trikot.png"),
  heatmap_pitch_fcb: require("../../../assets/wc/images/pitch_heatmap_transparent_fcb.png"),
};

export default assets;
